import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { extract, formatCrm } from '../../../util/util';
import ReactSelect from '../../../components/ReactSelect';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import { FinField, FinInput } from '../../../components/FinField';
import '../../../css/financeiro-parcela-pagar.css';

const UF_OPTIONS = [
    { value: "AC", label: "AC" },
    { value: "AL", label: "AL" },
    { value: "AP", label: "AP" },
    { value: "AM", label: "AM" },
    { value: "BA", label: "BA" },
    { value: "CE", label: "CE" },
    { value: "DF", label: "DF" },
    { value: "ES", label: "ES" },
    { value: "GO", label: "GO" },
    { value: "MA", label: "MA" },
    { value: "MT", label: "MT" },
    { value: "MS", label: "MS" },
    { value: "MG", label: "MG" },
    { value: "PA", label: "PA" },
    { value: "PB", label: "PB" },
    { value: "PR", label: "PR" },
    { value: "PE", label: "PE" },
    { value: "PI", label: "PI" },
    { value: "RJ", label: "RJ" },
    { value: "RN", label: "RN" },
    { value: "RS", label: "RS" },
    { value: "RO", label: "RO" },
    { value: "RR", label: "RR" },
    { value: "SC", label: "SC" },
    { value: "SP", label: "SP" },
    { value: "SE", label: "SE" },
    { value: "TO", label: "TO" },
];

export default function CadastroEventoPalestrante({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const history = useHistory();
    let { state } = useLocation();
    var evento = state?.evento ?? null;

    const buscar = () => {
        if (id) {
            api({
                method: "get",
                action: '/participante/' + id,
                token: token,
            }).then(response => {
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: [
                        'enderecopais',
                        'aereomunicipioembarque',
                        'enderecomunicipio',
                        'tipoparticipante',
                        'hotelmunicipio',
                        'banco',
                    ]
                });
                evento = dadosRecebidos.evento.id;
                setDados(dadosRecebidos);
            }).catch(err => {
                //console.log(err)
            });
        } else {
            setDados({
                ...dados,
                evento: evento,
                tipoCadastro: 'palestrante',
                tipoparticipante: 3, //3 - Palestrante Hcp (padrão do cadastro de palestrante)
            });
        }
    };

    const salvar = () => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        let dadosSalvar = { ...dados };
        delete dadosSalvar.enderecopais;
        delete dadosSalvar.aereomunicipioembarque;
        delete dadosSalvar.enderecomunicipio;
        delete dadosSalvar.hotelmunicipio;
        delete dadosSalvar.banco;
        delete dadosSalvar.situacaoevento;
        delete dadosSalvar.recebePergunta; // quem marca é a lista de Palestrantes do Q&A; o form aberto não devolve valor velho

        if (id) {
            delete dadosSalvar.evento;
            api({
                method: 'put',
                action: '/participante/' + id,
                token: token,
                data: dadosSalvar,
            }).then(() => {
                toast.success("As alterações foram salvas com sucesso!");
                history.push("/eventoPalestrante/" + evento);
            }).catch(error => {
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
            }).finally(() => {
                setIsSubmitting(false);
            });
        } else {
            api({
                method: 'post',
                action: '/participante',
                token: token,
                data: dadosSalvar,
            }).then(() => {
                toast.success("Dados salvos com sucesso!");
                history.push("/eventoPalestrante/" + evento);
            }).catch(error => {
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
            }).finally(() => {
                setIsSubmitting(false);
            });
        }
    };

    useEffect(() => {
        document.querySelector("#nome").focus();
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Palestrante</h1>
                        {dados.evento?.nome && <p className="fin-pp__subtitle">{dados.evento.nome}</p>}
                    </div>
                </div>

                <form onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <FinField label="Código">
                                <FinInput
                                    type="text"
                                    value={dados.codigo || ''}
                                    onChange={e => setDados({ ...dados, codigo: e.target.value })}
                                />
                            </FinField>
                            <FinField grow label="Nome">
                                <FinInput
                                    type="text"
                                    id="nome"
                                    value={dados.nome || ''}
                                    onChange={e => setDados({ ...dados, nome: e.target.value })}
                                />
                            </FinField>
                            <FinField label="Telefone">
                                <FinInput
                                    type="text"
                                    value={dados.telefone || ''}
                                    onChange={e => setDados({ ...dados, telefone: e.target.value })}
                                />
                            </FinField>
                            <FinField label="Telefone 2">
                                <FinInput
                                    type="text"
                                    value={dados.telefone2 || ''}
                                    onChange={e => setDados({ ...dados, telefone2: e.target.value })}
                                />
                            </FinField>
                            <FinField label="Celular">
                                <InputMask
                                    mask="(99) 99999-9999"
                                    className="fin-pp__input"
                                    style={{ paddingLeft: 14 }}
                                    id="celular"
                                    value={dados.celular || ''}
                                    onChange={e => setDados({ ...dados, celular: e.target.value })}
                                />
                            </FinField>
                            <FinField label="E-mail">
                                <FinInput
                                    type="text"
                                    value={dados.email || ''}
                                    onChange={e => setDados({ ...dados, email: e.target.value })}
                                />
                            </FinField>
                            <FinField full label="Outros E-mails">
                                <FinInput
                                    type="text"
                                    value={dados.emailsecundario || ''}
                                    onChange={e => setDados({ ...dados, emailsecundario: e.target.value })}
                                />
                            </FinField>
                            <FinField label="Especialidade">
                                <FinInput
                                    type="text"
                                    value={dados.especialidade || ''}
                                    onChange={e => setDados({ ...dados, especialidade: e.target.value })}
                                />
                            </FinField>
                            <FinField label="CRM">
                                <FinInput
                                    type="text"
                                    value={dados.crm || ''}
                                    onChange={e => {
                                        const r = formatCrm(e.target.value, dados?.crm, dados?.crmuf);
                                        setDados({ ...dados, crm: r.crm, crmuf: r.crmuf, nomeUf: r.crmuf });
                                    }}
                                />
                            </FinField>
                            <FinField label="Estado do CRM">
                                <ReactSelect
                                    id="crmuf"
                                    value={dados.crmuf ? { value: dados.crmuf, label: dados.crmuf } : null}
                                    onChange={e => {
                                        const crmuf = e ? e.value : '';
                                        const nomeUf = e ? e.label : '';
                                        const r = formatCrm((crmuf || '') + (dados?.crm ?? '').replace(/\D/g, ''), dados?.crm, crmuf);
                                        setDados({ ...dados, crmuf, nomeUf, crm: r.crm });
                                    }}
                                    options={UF_OPTIONS}
                                />
                            </FinField>
                            <FinField label="Instituição">
                                <FinInput
                                    type="text"
                                    value={dados.instituicao || ''}
                                    onChange={e => setDados({ ...dados, instituicao: e.target.value })}
                                />
                            </FinField>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting
                                ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Salvando...</>
                                : <><FaSave size={16} /> Salvar</>
                            }
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
